// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header book select - very compact on mobile */
@media (max-width: 600px) {
  .header-book-select {
    min-width: 42px !important;
    width: auto !important;
  }
  .header-book-select .MuiInputBase-root,
  .header-book-select .MuiNativeSelect-root {
    font-size: 10px !important;
    line-height: 1.1 !important;
    padding: 1px 22px 1px 3px !important;
    height: 22px !important;
    min-height: 22px !important;
    border-radius: 4px !important;
    background-color: rgba(255, 255, 255, 0.08) !important;
    color: #fff !important;
  }
  .header-book-select .MuiInputBase-input {
    padding: 2px 0 !important;
    line-height: 1.1 !important;
  }
  .header-book-select .MuiSelect-select {
    padding-right: 22px !important;
  }
  .header-book-select .MuiSvgIcon-root {
    right: 4px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    font-size: 14px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;;IAEE,0BAA0B;IAC1B,2BAA2B;IAC3B,oCAAoC;IACpC,uBAAuB;IACvB,2BAA2B;IAC3B,6BAA6B;IAC7B,sDAAsD;IACtD,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,sCAAsC;IACtC,0BAA0B;EAC5B;AACF","sourcesContent":["/* Header book select - very compact on mobile */\n@media (max-width: 600px) {\n  .header-book-select {\n    min-width: 42px !important;\n    width: auto !important;\n  }\n  .header-book-select .MuiInputBase-root,\n  .header-book-select .MuiNativeSelect-root {\n    font-size: 10px !important;\n    line-height: 1.1 !important;\n    padding: 1px 22px 1px 3px !important;\n    height: 22px !important;\n    min-height: 22px !important;\n    border-radius: 4px !important;\n    background-color: rgba(255, 255, 255, 0.08) !important;\n    color: #fff !important;\n  }\n  .header-book-select .MuiInputBase-input {\n    padding: 2px 0 !important;\n    line-height: 1.1 !important;\n  }\n  .header-book-select .MuiSelect-select {\n    padding-right: 22px !important;\n  }\n  .header-book-select .MuiSvgIcon-root {\n    right: 4px !important;\n    top: 50% !important;\n    transform: translateY(-50%) !important;\n    font-size: 14px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
